var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inertia-link',{attrs:{"href":_vm.url}},[_c('base-button',{staticClass:"base-button",attrs:{"outline":true,"label":_vm.label,"icon":_vm.iconName}},[(!!!_vm.label)?_c('q-tooltip',[_vm._v(" نمایش جزئیات بیشتر ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }